import React from 'react';
import { Link } from 'react-router-dom';
import { navigation, contact } from '../data/site';
export function SiteFooter() {
  return <footer className="border-t border-line bg-paper" data-id="element-105" data-mp="3r8rherbwqbyw">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 py-14 md:grid-cols-12 lg:px-10" data-id="element-106" data-mp="3mh13kbdrh62q">
        <div className="md:col-span-5" data-id="element-107" data-mp="3hipsxyfn6rjg">
          <p className="font-display text-2xl font-medium" data-id="element-108" data-mp="3hhojfye9yd3u">Elisabete Costa</p>
          <p className="mt-2 max-w-xs text-sm leading-relaxed text-ink-soft" data-id="element-109" data-mp="3dh4kcpa54zf2">
            Professeure de violoncelle et conseillère en performance & santé du musicien.
          </p>
        </div>
        <nav aria-label="Pied de page" className="md:col-span-4" data-id="element-110" data-mp="33hvizbcy4iio">
          <ul className="grid grid-cols-2 gap-x-6 gap-y-3 text-sm" data-id="element-111" data-mp="33khz3zdwk6ci">
            {navigation.map(item => <li key={item.to} data-id="element-112" data-mp="11r1yqas0jd4c">
                <Link to={item.to} className="text-ink-soft transition-colors duration-150 hover:text-ink" data-id="element-113" data-mp="11q91q1iuw1ze">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>
        <div className="text-sm md:col-span-3 md:text-right" data-id="element-114" data-mp="15pagdi2edel1">
          <a href={`mailto:${contact.email}`} className="text-ink transition-colors duration-150 hover:text-wood" data-id="element-115" data-mp="1aq874j1h3gy5">
            {contact.email}
          </a>
          <p className="mt-3 text-ink-soft" data-id="element-116" data-mp="vus59runigr7">© {new Date().getFullYear()} Elisabete Costa</p>
        </div>
      </div>
    </footer>;
}